import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './features/auth/AuthProvider';
import { AuthGuard } from './features/auth/AuthGuard';
import { theme } from './utils/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { 
  LoginPage,
  HomePage,
  PolicyPage,
  MainPage
} from './pages';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route path='/home' element={<HomePage />} />
            <Route path='/policy' element={<PolicyPage />} />
            <Route path='/admin/*' element={<AuthGuard><MainPage /></AuthGuard>} />
            <Route path='*' element={<LoginPage />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;